import { nodes } from 'ngx-editor';
import { paragraphNode } from '@nimbus-library/features/shared/components/material/input-rich-text/input-rich-text-nodes/paragraph-node.const';
import { imageNode } from '@nimbus-library/features/shared/components/material/input-rich-text/input-rich-text-nodes/image-node.const';
import {
  tableCellNode,
  tableHeaderNode,
  tableNode,
  tableRowNode,
} from '@nimbus-library/features/shared/components/material/input-rich-text/input-rich-text-nodes/table-nodes.const';

export const InputRichTextNodes: object = {
  ...nodes,
  paragraph: paragraphNode,
  image: imageNode,
  table: tableNode,
  tableRow: tableRowNode,
  tableCell: tableCellNode,
  tableHeader: tableHeaderNode,
};
